import CostColumnsData from './CostColumnsData';

export class ExportJobsDetailsColumnsData {
    public static getExportJobsDetailsColumn = (type: any) => {
        const data = [{
            headerClassName: 'data-table header',
            id: 'chargeItem-exportJobNumber',
            show: true,
            sortable: true,
            accessor: 'exportJobNumber',
            fieldHeader: 'Export Job No'
        }, {
            headerClassName: 'data-table header',
            id: 'chargeItem-salesOrderItem',
            show: true,
            sortable: true,
            accessor: 'salesOrderItem',
            fieldHeader: 'Sales Order Item'
        }, {
            headerClassName: 'data-table header',
            id: 'chargeItem-status',
            show: true,
            sortable: true,
            accessor: 'status',
            fieldHeader: 'Charge Item Status'
        }, {
            headerClassName: 'data-table header',
            show: true,
            accessor: (type === CostColumnsData.TYPES.REVENUE) ? 'billToPartyCode' : 'payToPartyCode',
            fieldHeader: (type === CostColumnsData.TYPES.REVENUE) ? 'Bill To Party Code' : 'Pay To Party Code',
            sortable: true
        }, {
            headerClassName: 'data-table header no-sorting',
            show: true,
            accessor: (type === CostColumnsData.TYPES.REVENUE) ? 'billToPartyName' : 'payToPartyName',
            fieldHeader: (type === CostColumnsData.TYPES.REVENUE) ? 'Bill To Party Name' : 'Pay To Party Name',
            sortable: false
        }, {
            headerClassName: 'data-table header',
            accessor: 'icb',
            fieldHeader: 'ICB',
            show: true,
            footer: null,
            sortable: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'quantity',
            fieldHeader: 'Quantity',
            show: true,
            footer: null,
            sortable: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'roe',
            fieldHeader: 'ROE',
            show: true,
            footer: null,
            sortable: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'errorReason',
            fieldHeader: 'Error Reason',
            show: true,
            footer: null,
            sortable: true
        }, {
            headerClassName: 'data-table header',
            accessor: (type === CostColumnsData.TYPES.COST) ? 'contractNumberItem' : 'errorReason',
            fieldHeader: 'Contract Number/Item',
            show: (type === CostColumnsData.TYPES.COST) ? true : false,
            footer: null,
            sortable: true
        },{
            headerClassName: 'data-table header',
            accessor: (type === CostColumnsData.TYPES.COST) ? 'infoRecord' : 'errorReason',
            fieldHeader: 'Info Record',
            show: (type === CostColumnsData.TYPES.COST) ? true : false,
            footer: null,
            sortable: true
        },{
            headerClassName: 'data-table header',
            show: true,
            accessor: 'pricingDate',
            fieldHeader: 'Pricing Date',
            footer: null,
            sortable: true
        }, {
            headerClassName: 'data-table header',
            show: true,
            accessor: (type === CostColumnsData.TYPES.REVENUE) ? 'billingDate' : 'tax',
            fieldHeader: (type === CostColumnsData.TYPES.REVENUE) ? `Billing Date` : `TAX`,
            footer: null,
            sortable: true
        }]
        return [...data]
    };

    public static getEquipmentDetailsColumn = () => {
        const data = [{
            headerClassName: 'data-table header',
            show: true,
            sortable: true,
            accessor: 'equipmentNumber',
            fieldHeader: 'Equipment No'
        }, {
            headerClassName: 'data-table header',
            show: true,
            sortable: true,
            accessor: 'containerSizeType',
            fieldHeader: 'Size/type'
        }, {
            headerClassName: 'data-table header',
            show: true,
            sortable: true,
            accessor: 'substitutionSizeType',
            fieldHeader: 'Sub/size/type'
        }, {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'documentNumber',
            fieldHeader: 'Primary doc(FCR)',
            sortable: true
        }, {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'bookingNumber',
            fieldHeader: 'Booking No',
            sortable: true
        }, {
            headerClassName: 'data-table header',
            accessor: 'quantity',
            fieldHeader: 'Quantity',
            show: true,
            footer: null,
            sortable: true
        }]
        return [...data]
    };
}
